import { useSelector } from "react-redux";
import { selectNewProductCategoryId, selectNewProductCategoryName } from "../../features/product/productSlice";

export const useIsCategoryName = (name: string): boolean => {
    const selectedCategoryName = useSelector(selectNewProductCategoryName);

    const catName1 = selectedCategoryName?.trim().toLowerCase()
    const catName2 = name?.trim().toLowerCase()

    return ( catName1 === catName2);
};

export const useIsCategoryId = (id: number): boolean => {
    const selectedCategoryId = useSelector(selectNewProductCategoryId);

    return ( selectedCategoryId === id);
};

// bottle drinks 
// type: None
// size: None

// pastries
// type: None
// size: None

// refresher
// type: ICED(only)
// size: Yes
